// AUTO-GENERATED by `cargo xtask gen-manifest` - DO NOT EDIT

import type { Highlight } from "./types.js"; 

/** Version of plugin packages (all @arborium/* packages share this version) */
export const pluginVersion = "2.18.2";

/** All available languages */
export const availableLanguages: string[] = [
  "ada",
  "agda",
  "asciidoc",
  "asm",
  "awk",
  "bash",
  "batch",
  "c",
  "c-sharp",
  "caddy",
  "capnp",
  "cedar",
  "cedarschema",
  "clojure",
  "cmake",
  "cobol",
  "commonlisp",
  "cpp",
  "css",
  "d",
  "dart",
  "devicetree",
  "diff",
  "dockerfile",
  "dot",
  "elisp",
  "elixir",
  "elm",
  "erlang",
  "fish",
  "fsharp",
  "gitattributes",
  "gleam",
  "glsl",
  "go",
  "graphql",
  "groovy",
  "haskell",
  "hcl",
  "hlsl",
  "html",
  "idris",
  "ini",
  "java",
  "javascript",
  "jinja2",
  "jq",
  "jsdoc",
  "json",
  "julia",
  "just",
  "kconfig",
  "kdl",
  "kotlin",
  "lean",
  "lua",
  "make",
  "markdown",
  "matlab",
  "meson",
  "nginx",
  "ninja",
  "nix",
  "objc",
  "ocaml",
  "odin",
  "perl",
  "php",
  "postscript",
  "powershell",
  "prolog",
  "proto",
  "python",
  "query",
  "r",
  "regex",
  "rego",
  "rescript",
  "ron",
  "ruby",
  "rust",
  "scala",
  "scheme",
  "scss",
  "solidity",
  "sparql",
  "sql",
  "ssh-config",
  "starlark",
  "styx",
  "svelte",
  "swift",
  "textproto",
  "thrift",
  "tlaplus",
  "toml",
  "tsx",
  "typescript",
  "typst",
  "uiua",
  "vb",
  "verilog",
  "vhdl",
  "vim",
  "vue",
  "wit",
  "x86asm",
  "xml",
  "yaml",
  "yuri",
  "zig",
  "zsh",
];

/** All possible highlights and their short tags */
export const highlights: Highlight[] = [
  {
    name: "attribute",
    tag: "at",
  },
  {
    name: "constant",
    tag: "co",
  },
  {
    name: "constant.builtin",
    tag: "cb",
    parentTag: "constant",
  },
  {
    name: "constructor",
    tag: "cr",
  },
  {
    name: "function.builtin",
    tag: "fb",
    parentTag: "function",
  },
  {
    name: "function",
    tag: "f",
  },
  {
    name: "function.method",
    tag: "fm",
    parentTag: "function",
  },
  {
    name: "keyword",
    tag: "k",
  },
  {
    name: "keyword.conditional",
    tag: "kc",
    parentTag: "keyword",
  },
  {
    name: "keyword.coroutine",
    tag: "ko",
    parentTag: "keyword",
  },
  {
    name: "keyword.debug",
    tag: "kd",
    parentTag: "keyword",
  },
  {
    name: "keyword.exception",
    tag: "ke",
    parentTag: "keyword",
  },
  {
    name: "keyword.function",
    tag: "kf",
    parentTag: "keyword",
  },
  {
    name: "keyword.import",
    tag: "ki",
    parentTag: "keyword",
  },
  {
    name: "keyword.operator",
    tag: "kp",
    parentTag: "keyword",
  },
  {
    name: "keyword.repeat",
    tag: "kr",
    parentTag: "keyword",
  },
  {
    name: "keyword.return",
    tag: "kt",
    parentTag: "keyword",
  },
  {
    name: "keyword.type",
    tag: "ky",
    parentTag: "keyword",
  },
  {
    name: "operator",
    tag: "o",
  },
  {
    name: "property",
    tag: "pr",
  },
  {
    name: "punctuation",
    tag: "p",
  },
  {
    name: "punctuation.bracket",
    tag: "pb",
    parentTag: "punctuation",
  },
  {
    name: "punctuation.delimiter",
    tag: "pd",
    parentTag: "punctuation",
  },
  {
    name: "punctuation.special",
    tag: "ps",
    parentTag: "punctuation",
  },
  {
    name: "string",
    tag: "s",
  },
  {
    name: "string.special",
    tag: "ss",
    parentTag: "string",
  },
  {
    name: "tag",
    tag: "tg",
  },
  {
    name: "tag.delimiter",
    tag: "td",
    parentTag: "tag",
  },
  {
    name: "tag.error",
    tag: "te",
    parentTag: "tag",
  },
  {
    name: "type",
    tag: "t",
  },
  {
    name: "type.builtin",
    tag: "tb",
    parentTag: "type",
  },
  {
    name: "type.qualifier",
    tag: "tq",
    parentTag: "type",
  },
  {
    name: "variable",
    tag: "v",
  },
  {
    name: "variable.builtin",
    tag: "vb",
    parentTag: "variable",
  },
  {
    name: "variable.parameter",
    tag: "vp",
    parentTag: "variable",
  },
  {
    name: "comment",
    tag: "c",
  },
  {
    name: "comment.documentation",
    tag: "cd",
    parentTag: "comment",
  },
  {
    name: "macro",
    tag: "m",
  },
  {
    name: "label",
    tag: "l",
  },
  {
    name: "diff.addition",
    tag: "da",
  },
  {
    name: "diff.deletion",
    tag: "dd",
  },
  {
    name: "number",
    tag: "n",
  },
  {
    name: "text.literal",
    tag: "tl",
  },
  {
    name: "text.emphasis",
    tag: "em",
  },
  {
    name: "text.strong",
    tag: "st",
  },
  {
    name: "text.uri",
    tag: "tu",
  },
  {
    name: "text.reference",
    tag: "tr",
  },
  {
    name: "string.escape",
    tag: "se",
    parentTag: "string",
  },
  {
    name: "text.title",
    tag: "tt",
  },
  {
    name: "text.strikethrough",
    tag: "tx",
  },
  {
    name: "spell",
    tag: "sp",
  },
  {
    name: "embedded",
    tag: "eb",
  },
  {
    name: "error",
    tag: "er",
  },
  {
    name: "namespace",
    tag: "ns",
  },
  {
    name: "include",
    tag: "in",
    parentTag: "keyword",
  },
  {
    name: "storageclass",
    tag: "sc",
    parentTag: "keyword",
  },
  {
    name: "repeat",
    tag: "rp",
    parentTag: "keyword",
  },
  {
    name: "conditional",
    tag: "cn",
    parentTag: "keyword",
  },
  {
    name: "exception",
    tag: "ex",
    parentTag: "keyword",
  },
  {
    name: "preproc",
    tag: "pp",
    parentTag: "keyword",
  },
  {
    name: "none",
    tag: "",
  },
  {
    name: "character",
    tag: "ch",
    parentTag: "string",
  },
  {
    name: "character.special",
    tag: "cs",
    parentTag: "string",
  },
  {
    name: "variable.member",
    tag: "vm",
    parentTag: "variable",
  },
  {
    name: "function.definition",
    tag: "fd",
    parentTag: "function",
  },
  {
    name: "type.definition",
    tag: "tf",
    parentTag: "type",
  },
  {
    name: "function.call",
    tag: "fc",
    parentTag: "function",
  },
  {
    name: "keyword.modifier",
    tag: "km",
    parentTag: "keyword",
  },
  {
    name: "keyword.directive",
    tag: "dr",
    parentTag: "keyword",
  },
  {
    name: "string.regexp",
    tag: "rx",
    parentTag: "string",
  },
  {
    name: "nospell",
    tag: "",
  },
  {
    name: "float",
    tag: "n",
  },
  {
    name: "boolean",
    tag: "cb",
  },
];